import * as Yup from 'yup'
import { differenceInYears, differenceInDays, parse } from 'date-fns'
import { useTranslation } from 'react-i18next'
import { checkEmailExists } from '../../services/user'

const useRegisterValidators = () => {
  const { t } = useTranslation()

  const schema = Yup.object().shape({
    birthday: Yup.string()
      .required(t('validation-birthday-required'))
      .test('is-valid-date', t('validation-birthday-typeError'), value => {
        if (!value) return false
        const parsedDate = parse(value, 'dd-MM-yyyy', new Date())
        return !isNaN(parsedDate.getTime())
      })
      .test('is-adult', t('validation-birthday-isAdult'), value => {
        if (!value) return false
        const today = new Date()
        const birthDate = parse(value, 'dd-MM-yyyy', new Date())
        const ageYears = differenceInYears(today, birthDate)
        const ageDays = differenceInDays(
          today,
          new Date(today.getFullYear() - 18, today.getMonth(), today.getDate()),
        )
        return ageYears >= 18 && ageDays >= 0
      }),
    nickname: Yup.string()
      .required(t('validation-nickname-required'))
      .min(3, t('validation-nickname-min'))
      .max(20, t('validation-nickname-max')),
    email: Yup.string()
      .email(t('validation-email-invalid'))
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        t('validation-email-invalid'),
      )
      .required(t('validation-email-required'))
      .test('is-unique', t('email-already-taken'), async value => {
        if (!value) return false
        const isTaken = await checkEmailExists(value)
        return !isTaken
      }),
    city: Yup.string().required(t('validation-city-required')),
    password: Yup.string()
      .min(8, t('validation-password-min'))
      .matches(/[A-Z]/, t('validation-password-uppercase'))
      .matches(/[0-9]/, t('validation-password-number'))
      .required(t('validation-password-required')),
    passwordConfirmation: Yup.string()
      .oneOf([Yup.ref('password')], t('passwords-do-not-match'))
      .required(t('validation-password-confirmation-required')),
  })

  return schema
}

export default useRegisterValidators
